import AskQuestion from "@/components/product-details/questions/ask";
import QuestionSuccessFullSubmit from "@/components/product-details/questions/successfullSubmit";
import React, { useState, useRef } from "react";
import { ModalWrapper } from "../ModalWrapper";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { askQuestionSchema } from "@/utils/validation/schema/product";
import { usePostProductQuestion } from "@/api/client/product";

function ProductQuestionModal({ product_slug }) {
  const [isQuestionSubmitted, setIsQuestionSubmitted] = useState(false);
  const closeQuestionModalRef = useRef();

  const { isLoading: isProductQuestionLoading, mutate: creteProductQuestion } =
    usePostProductQuestion({
      onSuccess: () => {
        setIsQuestionSubmitted(true);
      },
      onError: (errorData) => {
        errorData.errors.forEach(({ name, message }) => {
          setError(name, { message });
        });
      },
    });

  const {
    register,
    handleSubmit,
    setError,
    reset: resetReviewForm,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(askQuestionSchema),
  });

  const onSubmit = (data) => {
    creteProductQuestion({ product_slug, question: data.question });
  };

  const handleCloseModal = () => {
    resetReviewForm();
    setIsQuestionSubmitted(false);
    closeQuestionModalRef?.current?.click();
  };

  return (
    <>
      <ModalWrapper
        ref={closeQuestionModalRef}
        modalId="askProductQuestionModal"
        onClose={handleCloseModal}
        title={isQuestionSubmitted ? "" : "Ask Question"}
        isFullHeight={true}
      >
        {isQuestionSubmitted ? (
          <QuestionSuccessFullSubmit onClick={handleCloseModal} />
        ) : (
          <AskQuestion
            onClose={handleCloseModal}
            register={register}
            handleSubmit={handleSubmit(onSubmit)}
            errors={errors}
            isProductQuestionLoading={isProductQuestionLoading}
          />
        )}
      </ModalWrapper>
    </>
  );
}

export default ProductQuestionModal;
